<template>
  <v-tabs>
    <v-tab>Products</v-tab>
    <v-tab>Product Categories</v-tab>
    <v-tab-item>
      <products :canAddProducts="canAddProducts" />
    </v-tab-item>
    <v-tab-item>
      <product-categories />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Products from "./Products";
import ProductCategories from "./ProductCategories";
import { hasPermission } from "@/modules/rbac/permission-manifest";

export default {
  name: "ProductManagement",
  inject: ["snackBar", "reactiveInjected"],
  data() {
    return {
      canAddProducts: hasPermission(
        "canCreateProduct",
        null,
        this.reactiveInjected.activeUser
      ),
    };
  },
  components: { Products, ProductCategories },
};
</script>
